export function avatarColors(firstLetter: string) {
  const first = firstLetter.toLocaleUpperCase();
  const colorArray = [
    "#97DA9A",
    "#68C2D3",
    "#AE8BF3",
    "#FBAA74",
    "#F582A8",
    "#7EA0D7",
    "#6E6D6E",
    "#CD9B80",
    "#EA79D0",
    "#E77480",
    "#96AF50",
    "#E08956",
    "#EC4A57",
    "#3E829A",
    "#BF5E9B",
    "#5D72BF",
    "#BF665E",
    "#CE5CB9",
    "#32A285",
    "#466BD1",
    "#D9AA53",
    "#E86E53",
    "#7C8AF8",
    "#66D1B4",
    "#BF9E48",
    "#569FE8",
  ];

  return colorArray[first.charCodeAt(0)-65]
}
